module.exports = __webpack_public_path__ + "img/3.856ef7ff.png";